import React from "react";
import "../CSS/OpportunityDetailsModal.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const OpportunityDetailsModal = ({
  opportunity,
  onClose
}) => {

  const navigate = useNavigate();
  if (!opportunity) {
    return null;
  }

  

  const handleNavigation = () =>{

    

  const username = Cookies.get("userID");


   if (username == null) {
      navigate("/login");
      return;
    }

    alert('Application succesful')

  }

  return (
    <div
      className="opportunity-modal-overlay"
      onClick={onClose}
    >
      <div
        className="opportunity-modal"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="opportunity-modal-header">
          <div className="opportunity-modal-brand">
            <div className="modal-organization-logo">
              {opportunity.organization?.charAt(0)}
            </div>

            <div>
              <span>
                ATTACHMENT OPPORTUNITY
              </span>

              <h2>
                {opportunity.title}
              </h2>
            </div>
          </div>

          <button
            className="opportunity-modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="opportunity-modal-body">
          <div className="modal-organization">
            <strong>
              {opportunity.organization}
            </strong>

            <span>
              {opportunity.category}
            </span>
          </div>

          <div className="modal-info-grid">
            <div className="modal-info-card">
              <span>
                COUNTY LOCATION
              </span>

              <strong>
                ◉ {opportunity.county}
              </strong>
            </div>

            <div className="modal-info-card">
              <span>
                DURATION
              </span>

              <strong>
                ◷ {opportunity.duration}
              </strong>
            </div>

            <div className="modal-info-card">
              <span>
                OPENINGS
              </span>

              <strong>
                {opportunity.openings}
              </strong>
            </div>

            <div className="modal-info-card">
              <span>
                APPLICATIONS
              </span>

              <strong>
                {opportunity.applications || 0}
              </strong>
            </div>
          </div>

          <section className="modal-section">
            <span className="modal-section-label">
              ABOUT THE OPPORTUNITY
            </span>

            <p>
              {opportunity.description}
            </p>
          </section>

          {opportunity.requirements?.length > 0 && (
            <section className="modal-section">
              <span className="modal-section-label">
                ELIGIBLE COURSES
              </span>

              <div className="modal-tags">
                {opportunity.requirements.map(
                  (requirement, index) => (
                    <span key={index}>
                      {requirement}
                    </span>
                  )
                )}
              </div>
            </section>
          )}

          {opportunity.responsibilities?.length > 0 && (
            <section className="modal-section">
              <span className="modal-section-label">
                WHAT YOU'LL DO
              </span>

              <ul className="modal-list">
                {opportunity.responsibilities.map(
                  (responsibility, index) => (
                    <li key={index}>
                      <span>✓</span>
                      {responsibility}
                    </li>
                  )
                )}
              </ul>
            </section>
          )}

          <div className="modal-extra-grid">
            <div>
              <span>
                POSTED
              </span>

              <strong>
                {opportunity.posted}
              </strong>
            </div>

            <div>
              <span>
                CONTACT
              </span>

              <strong>
                {opportunity.contactEmail ||
                  "Contact organisation"}
              </strong>
            </div>
          </div>
        </div>

        <div className="opportunity-modal-footer">
          <button
            className="modal-close-button"
            onClick={onClose}
          >
            Close
          </button>

          <button
            className="modal-apply-button"
            onClick={handleNavigation}
          >
            Apply for attachment →
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpportunityDetailsModal;